module.exports = __webpack_public_path__ + "img/money-money.312506a5.svg";